<template>
    <div>
        <v-dialog
                v-model="dialog"
                fullscreen
                lazy
        >

            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>Como llegar a: {{name}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn @click="close()" dark icon>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container grid-list-md text-xs-left>
                <v-card-text>
                    <v-flex d-flex lg12 md12 sm12 xs12>
                        <v-flex d-flex lg12 md12 sm12 xs12 style="text-align: center;">
                    <map-route :latlng="originLatLng"/>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="close()" color="success"
                           small>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import MapRoute from '@/components/widgets/maps/GeoMapsRoute'

export default {
  name: 'DialogMapRoute',
  components: {
    MapRoute
  },
  props: {
    modal: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: false,
      default: 'No se ha elegido localizacion'
    },
    stadium: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    dialog: {
      get () {
        return this.modal
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    originLatLng () {
      if (!this.stadium || !this.stadium.lat || !this.stadium.long) {
        return { latlng: { lat: 0, lng: 0 } }
      }
      return { latlng: { lat: this.stadium.lat, lng: this.stadium.long } }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
